module.exports = __webpack_public_path__ + "img/step_4-2.aa1995f1.png";